import determineFieldType from '../common/determineFieldType';
import { requestGet as wsRequestGet, requestPost as wsRequestPost } from './_wsApiFetchData';

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}

export async function searchFacility(options, language, timeZone, cancelToken) {
  const { skipPages, resultsCount, filters } = options;
  const { type, category, name, providerId, facilityId } = filters;

  const params = {
    'Order.By': 'CreatedAt',
    'Order.Direction': 'Desc',
    'Paging.Number': skipPages || 1,
    'Paging.Count': resultsCount,
    Id: facilityId,
    Name: name,
    Category: category,
    Type: type,
    ProviderId: providerId
  };

  return (await wsRequestGet('/admin/facility/search', language, timeZone, params, cancelToken))
    .map(x => toPascal(x));
}

export async function lookupFacility(options, language, timeZone, cancelToken) {
  const { key } = options;

  if (!key) {
    return [];
  }

  const optionsSearch = {
    resultsCount: 5,
    filters: {
      name: key
    }
  };

  const results = await searchFacility(optionsSearch, language, timeZone, cancelToken);

  return results.map(({ Id, Name }) => ({
    label: `${Name}`,
    value: Id
  }));
}

export async function searchFacilityFromReportsTable(options, language, timeZone, cancelToken) {
  const { skipPages, resultsCount, filters } = options;
  const { type, category, name, providerName, } = filters;

  const params = {
    'Order.By': 'CreatedAt',
    'Order.Direction': 'Desc',
    'Paging.Number': skipPages || 1,
    'Paging.Count': resultsCount,
    Name: name,
    Category: category,
    Type: type,
    ProviderName: providerName
  };

  return (await wsRequestGet('/admin/facility/search-from-report-table', language, timeZone, params, cancelToken))
    .map(x => toPascal(x));
}

export async function getFacility(id, language, timeZone, cancelToken) {
  var a =  toPascal(await wsRequestGet(`/admin/facility/${id}`, language, timeZone, null, cancelToken));

  return a;
}

export async function editFacilityData(
  {
    Id,
    CreatedAt,
    Provider,
    Area,
    Name,
    PlaceWebsiteUrl,
    PlacePhoneNumber,
    PlaceAddress,
    PlaceEmailAddress,
    PlaceLogoUrl,
    PlacePhotoUrl,
    PlacePhotoListUrl,
    PlacePhotoListPreviewUrl,
    PlacePhotoSquareUrl,
    PlacePhotoSquarePreviewUrl,
    PlacePhotoHugeUrl,
    PlacePhotoHugePreviewUrl,
    LockerId,
    PicturePreview,
    Slug
  },
  language,
  timeZone,
  cancelToken
) {
  return toPascal(await wsRequestPost('/admin/facility/edit', language, timeZone, {
    Id,
    CreatedAt,
    ProviderId: Provider.value,
    AreaId: Area.value,
    Name,
    Contact: {
      Name: '',
      PhoneNumber: {
        Number: ''
      },
      EmailAddress: {
        Email: ''
      }
    },
    PlaceOpeningHours: [],
    Type: 'Undefined',
    Category: 'None',
    LockerId: LockerId || undefined,
    PlaceWebsiteUrl,
    PlacePhoneNumber: {
      Number: PlacePhoneNumber.Number
    },
    PlaceName: Name,
    PlaceMapsUrl: '',
    PlaceLogoUrl,
    PlacePhotoUrl: PlacePhotoUrl || '1ee9d569-4a6d-4e2e-b325-300b946f9923-list',
    PlacePhotoListUrl,
    PlacePhotoListPreviewUrl,
    PlacePhotoSquareUrl,
    PlacePhotoSquarePreviewUrl,
    PlacePhotoHugeUrl,
    PlacePhotoHugePreviewUrl,
    PicturePreview,
    PlaceRating: 0,
    PlaceAddress: {
      String: PlaceAddress.String,
      Location: {
        Latitude: parseFloat(PlaceAddress.Location.Latitude),
        Longitude: parseFloat(PlaceAddress.Location.Longitude)
      }
    },
    PlaceEmailAddress: {
      Email: PlaceEmailAddress.Email
    },
    PlaceArea: 'some area',
    PlaceId: '',
    Slug: Slug || ''
  },
  null,
  cancelToken));
}

export async function saveNewFacilityData(
  {
    Provider,
    Area,
    PicturePreview,
    Name,
    ContactName,
    ContactEmail,
    ContactNumber,
    Type,
    Category,
    LockerId,
    PlaceEmailAddressInner,
    PlaceWebsiteUrl,
    PlacePhoneNumber,
    PlaceAddressText,
    PlaceLatitude,
    PlaceLongitude,
    PlaceMapsUrl,
    PlaceLogoUrl,
    PlacePhotoUrl,
    PlacePhotoListUrl,
    PlacePhotoListPreviewUrl,
    PlacePhotoSquareUrl,
    PlacePhotoSquarePreviewUrl,
    PlacePhotoHugeUrl,
    PlacePhotoHugePreviewUrl,
    PlaceId,
    PlaceOpeningHours,
    Slug
  },
  language,
  timeZone,
  cancelToken
) {

  return toPascal(await wsRequestPost('/admin/facility/create', language, timeZone, {
    ProviderId: Provider.value,
    AreaId: Area.value,
    Name,
    Contact: {
      Name: ContactName,
      PhoneNumber: {
        Number: ContactNumber
      },
      EmailAddress: {
        Email: ContactEmail
      }
    },
    PlaceOpeningHours,
    Type,
    Category: Category || 'None',
    LockerId: LockerId || undefined,
    PlaceWebsiteUrl,
    PlacePhoneNumber: {
      Number: PlacePhoneNumber
    },
    PlaceName: Name,
    PlaceMapsUrl,
    PlaceLogoUrl,
    PlacePhotoUrl: PlacePhotoUrl || '1ee9d569-4a6d-4e2e-b325-300b946f9923-list',
    PlacePhotoListUrl,
    PlacePhotoListPreviewUrl,
    PlacePhotoSquareUrl,
    PlacePhotoSquarePreviewUrl,
    PlacePhotoHugeUrl,
    PlacePhotoHugePreviewUrl,
    PlaceRating: 0,
    PlaceAddress: {
      String: PlaceAddressText,
      Location: {
        Latitude: parseFloat(PlaceLatitude),
        Longitude: parseFloat(PlaceLongitude)
      }
    },
    PlaceEmailAddress: {
      Email: PlaceEmailAddressInner
    },
    PlaceArea: 'some area',
    PlaceId: PlaceId || '',
    PicturePreview: PicturePreview || '',
    Slug: Slug || ''
  },
  null,
  cancelToken));
}

export async function lookupByNameOrId(key, language, timeZone, cancelToken) {
  if (!key) {
    return [];
  }

  const fieldName = await determineFieldType(key);

  const supportedFields = ['Id', 'Name'];

  if (supportedFields.indexOf(fieldName) < 0) {
    return [];
  }

  if (fieldName === 'Id') {
    const { Id, Name } = await getFacility(key, language, timeZone, cancelToken);

    return [{
      label: `${Name}`,
      value: Id
    }];
  } if (fieldName === 'Name') {
    const options = {
      resultsCount: 5,
      filters: {
        name: key
      }
    };

    const results = await searchFacility(options, language, timeZone, cancelToken);

    return results.map(({ Id, Name }) => ({
      label: `${Name}`,
      value: Id
    }));
  }
}

export async function lookupByName(key, language, timeZone, cancelToken) {
  if (!key) {
    return [];
  }

  const options = {
    resultsCount: 35,
    filters: {
      name: key
    }
  };

  const results = await searchFacilityFromReportsTable(options, language, timeZone, cancelToken);

  return results.map(({ Id, Name }) => ({
    label: `${Name}`,
    value: Id
  }));
  
}
